import { AppFeatures } from "../../../../constants/featureFlags";
import { AppFeatureUtils } from "../../../../utils";
import { links } from "./Config.resource";

export const getCrossSell = (props = {}) => {
  const { onClickHandler, userCountry, isAuthenticated } = props;

  const isGermanyRegulationEnabled = AppFeatureUtils.findIfIsInFeature(
    AppFeatures.GERMANY_REGULATION
  );

  if (userCountry?.toUpperCase() === "DEU" && isGermanyRegulationEnabled) {
    return null;
  }

  return {
    casinoProps: {
      ariaLabel: "casino online",
      className: "casinoBrand",
      onClick: onClickHandler.onClickCasino,
      href: links.casinoUrl,
      rel: "noopener noreferrer",
      svgId: "default-logo",
      svgText: "casino",
      name: "cross sell_888casino",
      dataTestId: "uc-cross-sell-casino"
    },
    sportProps: {
      ariaLabel: "sport online",
      className: "sportBrand",
      onClick: onClickHandler.onClickSport,
      href: isAuthenticated ? links.sportUrlAuthenticated : links.sportUrl,
      rel: "noopener noreferrer",
      svgId: "default-logo",
      svgText: "sport",
      name: "cross sport sell_888sport",
      dataTestId: "uc-cross-sell-sport"
    },
    pokerProps: {
      ariaLabel: "poker online",
      className: "pokerBrand active",
      onClick: onClickHandler.onClickPoker,
      href: links.pokerUrl,
      rel: "noopener noreferrer",
      svgId: "default-logo",
      svgText: "poker",
      name: "cross sell_888poker",
      dataTestId: "uc-cross-sell-poker"
    }
  };
};
